import React, { useEffect, useState } from 'react';
import { useMutation } from '@apollo/client/react';
import { VERIFY_INTAKE_EMAIL } from '../graphql/clubModel/ClubMutation';

export default function VerifyIntakeEmail({ signedIn }) {
    const [params] = useState(() => {
        const query = new URLSearchParams(window.location.search);
        const result = { challengeId: query.get('challenge'), secret: query.get('secret') };
        return result;
    });
    useEffect(() => {
        // Keep the proof in component memory, not browser history.
        window.history.replaceState(window.history.state, '', window.location.pathname);
    }, []);
    const [verify, { loading }] = useMutation(VERIFY_INTAKE_EMAIL);
    const [verified, setVerified] = useState(false);
    const [error, setError] = useState('');
    const confirm = async () => {
        setError('');
        try {
            await verify({ variables: params });
            setVerified(true);
        } catch {
            setError('This link could not be verified. Use the same venue account that requested it, or request a new link from the intake form.');
        }
    };
    return <main className="alcohol-intake-panel" style={{ padding: 32 }}>
        <h1>Verify venue email</h1>
        {verified ? <p role="status">Email verified. Return to the original alcohol intake form tab and publish your changes.</p>
            : !params.challengeId || !params.secret ? <p role="alert">This verification link is incomplete. Request a new link from the alcohol intake form.</p>
                : !signedIn ? <p>Sign in to the venue account in <a href="/" target="_blank" rel="noreferrer">another tab</a>, then return here to confirm your email.</p>
                    : <>
                        <p>Confirm your email to allow the pricing changes requested from the alcohol intake form. Only confirm if you requested those changes.</p>
                        <button type="button" disabled={loading} onClick={confirm}>{loading ? 'Verifying…' : 'Confirm venue email'}</button>
                    </>}
        {error && <p role="alert">{error}</p>}
    </main>;
}
